import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import {useDispatch, useSelector} from "react-redux";
import { useSetState } from "Helpers/Hooks";
import {DialogActions, Grid} from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { read } from "Helpers/LocalStorage";
import { editUser, selectUserGroup } from "Stores/actions";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { toggleNAciveDiActive } from "Constants/Constants";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import UserService from "Services/http/endpoints/user/UserService";
import StatusHandler from "Helpers/StatusHandler";
import MuiButton from "Components/MuiButton/MuiButton";
import {convertToEnglishNumber} from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as Icons from "react-bootstrap-icons";

function EditUsers({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { userGroupDataPagination, userGroupDataSearch } = useSelector((state) => ({
    userGroupDataPagination: state.user.userGroupDataPagination,
    userGroupDataSearch: state.user.userGroupDataSearch,

  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({
    userName: {
      type: "text",
      value: row.UserName,
      validation: null,
      readOnly:true
    },
    displayUser: {
      type: "text",
      value: row.DisplayName,
      validation: {
        required: true,
      },
    },

    // email: {
    //   type: "text",
    //   value: row.Email,
    //   validation: null,
    // },
    mobile: {
      type: "phone",
      value: row.PhoneNumber,
      validation: {
        required: true,
        isNumeric: true,
        isPhone: true,
        minLength: 11,
      },
    },
    userGroup: {
      type: "select",
      selectItems: [],
      value: row.IdGroup,
      validation: null,
    },
    // stypeUser: {
    //   type: "select",
    //   selectItems: [],
    //   value: row.dataComboStypePanel,
    //   validation: null,
    // },
    status: {
      type: "toggle",
      arrayItems: toggleNAciveDiActive,
      value: toggleNAciveDiActive.find(i => i.value === row.Active),
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: true }));
  };

  const handleDialog = () => setShowDialog(!showDialog);
  
  const onClear = () => {
    setFormValid({});
    setControls({ displayUser: { value: row.DisplayName } });
    setControls({ userName: { value: row.UserName } });
    setControls({ email: { value: row.Email } });
    setControls({ mobile: { value: row.PhoneNumber.replace("+98" , "0") } });
    setControls({ userGroup: { value: row.IdGroup } });
    setControls({ stypeUser: { value: row.dataComboStypePanel } });
    setControls({ status: { value: toggleNAciveDiActive.find(i => i.value === row.Active) } });
  };

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
      const response = await UserService.getGroupPriceUser(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const Grouper = response.data.Value;
        const update = Grouper.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        const groupValue = update.find((g) => g.value === row.GroupPrice);
        setControls({ userGroup: { value: groupValue } });
        setControls({ userGroup: { selectItems: update } });
      }
     /* const responsegetCombo = await UserService.getComboStypePanel(params);
      let e = StatusHandler(responsegetCombo);
      if (!e.isFail) {
        const Grouper = responsegetCombo.data.Value;
        const update = Grouper.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        const typeValue = update.find((g) => g.value === row.StypePanelId);
        setControls({ stypeUser: { value: typeValue } });
        setControls({ stypeUser: { selectItems: update } });
      }*/
        setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };


  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const {
        userGroup,
        mobile,
        email,
        userName,
        displayUser,
        status,
      } = controls;
      const enPhone =convertToEnglishNumber(mobile.value)
      const phoneWithCode = enPhone.replace("0" , "+98")
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUs: read("userKey"),
          Name: displayUser.value,
          Email: email.value,
          PhoneNumber: phoneWithCode,
          UserName: userName.value,
          //Password: "password",
          //ConfirmPassword: "password",
          //Stu: 2, //? whats that
          IdGroupPrice: userGroup.value.Id,
        //  Stp: stypeUser.value.Id,
          Active: status.value.value,
          //todo add listId: stypeUser.value.id,
        };
        await dispatch(editUser(data));
        //! seo
        const params = {
          Key: read("groupKey"),
          KeyUs: read("userKey"),
          Limit: userGroupDataPagination.Limit,
          Page: userGroupDataPagination.Page,
          Name: userGroupDataSearch?.Name,
        };
        await dispatch(selectUserGroup(params));
        onClear();
      } catch (err) {
      console.error('[catch error]', err)
    }
      handleDialog();
    } else if (R.isEmpty(formValid)) {
      handleDialog();
    }else {
      showNotify({
        text: t('correctFormDataRequired'),
        customClass: "error",
      });
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="virayesh_users" />
            </p>
          </div>
          <DialogContent>
            {
              !loading ? (
              <Grid container spacing={1}>
                {
                  Object.keys(controls).filter(key => controls[key].readOnly).map((key, index) => {
                    return (
                      <Grid xs={12} className="show-user-name">
                        <span>{`${t(key)} :`}</span>
                        <p>{controls[key].value}</p>
                      </Grid>
                    )
                  })
                }
                {
                  Object.keys(controls).filter(key => !controls[key].readOnly).map((key, index) => {
                    return (
                      <Grid item xs={12} key={key + index}>
                        {
                          controls[key].type === "text" &&
                          <Input
                            setValue={setValue.bind(this)}
                            name={key}
                            validation={controls[key].validation}
                            label={<Translator id={key} />}
                            type="text"
                            value={controls[key].value}
                            readOnly={controls[key].readOnly}
                          />
                        }
                        {
                          controls[key].type === "phone" &&
                          <Input
                            setValue={setValue.bind(this)}
                            name={key}
                            validation={controls[key].validation}
                            label={<Translator id={key} />}
                            type="text"
                            className={"phone"}
                            maxlength= "11"
                            helperText={'mobileExample'}
                            value={controls[key].value}
                          />
                        }
                        {
                          controls[key].type === "select" &&
                          <MuiAutoComplete
                            loading={loading}
                            options={controls[key].selectItems}
                            label={<Translator id={key} />}
                            value={controls[key].value}
                            id={key}
                            onChange={autoCompleteHandler}
                          />
                        }
                        {
                          controls[key].type === "toggle" &&
                          <MuiRadioGroup
                            name={key}
                            label={<Translator id={key} />}
                            value={controls[key].value}
                            items={controls[key].arrayItems}
                            onChange={onChangeToggle}
                            translate={true}
                            className="horizontalRadio"
                          />
                        }
                      </Grid>
                    );
                  })
                }
              </Grid>
            ) : (
              <MuiSkeleton xs={4} number={12} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default EditUsers;
